<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-30 17:29:20
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:04:04
 * @name: 添加或编辑权限
 * @Description: 添加或编辑权限(按是否传id区分)
 * @FilePath: \preSaleNafterSaleBackstage\src\components\role\role-edit-add.vue
 * @Author: desktop
-->
<template>
  <el-dialog :title="title" :visible.sync="show" @close="close">
    <div class="form">
      <div class="role_name">
        <span class="label">角色名称</span>
        <el-input
          class="input"
          v-model="form.role_name"
          placeholder="请输入角色名称..."
          clearable
        ></el-input>
      </div>
      <div class="auth_list">
        <span class="label">角色权限</span>
        <el-tree
          class="tree"
          node-key="id"
          ref="tree"
          show-checkbox
          :check-on-click-node="false"
          :expand-on-click-node="false"
          :data="authList"
          :props="defaultProps"
        ></el-tree>
      </div>
      <div class="btn-group">
        <el-button size="small" plain @click="show = false">取消</el-button>
        <el-button size="small" type="primary" @click="save">保存</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {
  adminRoleAuthList,
  adminRoleDetail,
  adminRoleAdd,
  adminRoleEdit,
} from "@/api/admin_role/admin_role.api";
import { debounceation } from "@/utils/decorator";
export default {
  data() {
    return {
      show: false,
      id: "",
      title: "",
      form: {
        role_name: "",
      },
      authList: [],
      defaultProps: {
        children: "submenu",
        label: "name",
      },
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 筛选出最底子节点
     * @param {Array} roleAuth 选中节点
     * @param {Array} authList 所有节点
     */
    filterRole(roleAuth, authList) {
      let arr = [];
      const checked = (id, data, newArr) => {
        data.forEach((item) => {
          if (item.id === id) {
            if (!item.submenu || item.submenu.length === 0) {
              newArr.push(item.id);
            }
          } else {
            if (item.submenu && item.submenu.length !== 0) {
              checked(id, item.submenu, newArr);
            }
          }
        });
      };
      roleAuth.forEach((x) => {
        checked(x, authList, arr);
      });
      return arr;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {String} id 角色id
     */
    open(id) {
      this.title = id ? "编辑角色" : "添加角色";
      this.id = id;
      let params = {};
      id && (params.role_id = id);
      adminRoleAuthList(params).then((res) => {
        this.authList = res.data.authList;
        adminRoleDetail({ id }).then((res2) => {
          let roleAuth =
            res2.data?.role_auth?.split(",")?.map((x) => Number(x)) ?? [];
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(
              this.filterRole(roleAuth, res.data.authList)
            );
          });
          this.form.role_name = res2.data?.role_name ?? "";
        });
        this.show = true;
      });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.form.role_name = "";
      this.authList = [];
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击保存
     */
    @debounceation(300)
    save() {
      let role_auth = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys());
      let role_name = this.form.role_name;
      let params = { role_auth, role_name };
      if (this.id) {
        params.id = this.id;
        adminRoleEdit(params).then((res) => {
          this.$message.success("保存成功");
          this.$emit("saveSuccess");
          this.show = false;
        });
      } else {
        adminRoleAdd(params).then((res) => {
          this.$message.success("保存成功");
          this.$emit("saveSuccess");
          this.show = false;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
  @extend .extend-flex-column-center;
  .role_name {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    @extend .extend-flex-start;
    .label {
      font-size: $Vars-font-miniTitle-size;
      flex-shrink: 0;
      margin-right: 20px;
    }
    .input {
      flex: 1;
    }
  }
  .auth_list {
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    margin-top: 30px;
    @extend .extend-flex-normal;
    .label {
      font-size: $Vars-font-miniTitle-size;
      flex-shrink: 0;
      margin-right: 20px;
    }
    .tree {
      flex: 1;
      margin: 0 20px;
    }
  }
  .btn-group {
    margin-top: 20px;
  }
}
</style>